var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'busyCursor': _vm.$store.state.busyCursor},attrs:{"id":"app"}},[_c('router-view',{staticClass:"flex-grow"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }